import { FC } from 'react';

import { toYmd } from '../../utils/rebate-settlement.utils';

// ─────────────────────────────────────────────
// DateFilter
//
// 미정산 내역의 배송완료일 기간 필터(시작~종료 + 이번달/지난달/전체기간 단축).
// 업체정산·상조정산 두 미정산 섹션이 공유한다.
// (bugo의 DateFilterSearcher와는 무관한 별개 컴포넌트 — 순수 input 기반)
// ─────────────────────────────────────────────

export interface DateFilterProps {
  dateFrom: string;
  dateTo: string;
  onFrom: (v: string) => void;
  onTo: (v: string) => void;
}

export const DateFilter: FC<DateFilterProps> = ({ dateFrom, dateTo, onFrom, onTo }) => (
  <div className="mb-3 flex flex-wrap items-center gap-2 text-sm">
    <span className="text-gray-500">기간(배송완료일)</span>
    <input
      type="date"
      value={dateFrom}
      max={dateTo || undefined}
      onChange={(e) => onFrom(e.target.value)}
      className="rounded border border-gray-300 px-2 py-1"
    />
    <span className="text-gray-400">~</span>
    <input
      type="date"
      value={dateTo}
      min={dateFrom || undefined}
      onChange={(e) => onTo(e.target.value)}
      className="rounded border border-gray-300 px-2 py-1"
    />
    <button
      onClick={() => {
        const n = new Date();
        onFrom(toYmd(new Date(n.getFullYear(), n.getMonth(), 1)));
        onTo(toYmd(new Date(n.getFullYear(), n.getMonth() + 1, 0)));
      }}
      className="rounded-full border border-gray-300 bg-white px-3 py-1 text-gray-600 hover:bg-gray-50"
    >
      이번달
    </button>
    <button
      onClick={() => {
        const n = new Date();
        onFrom(toYmd(new Date(n.getFullYear(), n.getMonth() - 1, 1)));
        onTo(toYmd(new Date(n.getFullYear(), n.getMonth(), 0)));
      }}
      className="rounded-full border border-gray-300 bg-white px-3 py-1 text-gray-600 hover:bg-gray-50"
    >
      지난달
    </button>
    {(dateFrom || dateTo) && (
      <button
        onClick={() => {
          onFrom('');
          onTo('');
        }}
        className="rounded-full border border-gray-300 bg-white px-3 py-1 text-gray-500 hover:bg-gray-50"
      >
        전체기간 ✕
      </button>
    )}
  </div>
);
